import {
    SET_CATEGORIES_BENEFITS_MARKETPLACE,
    SET_CATEGORY_TYPE_MARKETPLACE,
    SET_SUBCATEGORIES_MARKETPLACE,
    SET_CATEGORIES_ID_MARKETPLACE,
    SET_CATEGORIES_MARKETPLACE,
    SET_MODO_MARKETPLACE,
} from "@/views/categories_marketplace/store/types/types.js";

const mutations = {
    [SET_CATEGORIES_BENEFITS_MARKETPLACE]: (state, payload) => state.categories_marketplace_benefits = payload,
    [SET_CATEGORY_TYPE_MARKETPLACE]: (state, payload) => state.categories_type_marketplace = payload, 
    [SET_SUBCATEGORIES_MARKETPLACE]: (state, payload) => state.subcategories_marketplace = payload, 
    [SET_CATEGORIES_MARKETPLACE]: (state, payload) => state.categories_marketplace = payload,  
    [SET_CATEGORIES_ID_MARKETPLACE]: (state, payload) => state.categoryM = payload, 
    [SET_MODO_MARKETPLACE]: (state, payload) => state.modos_marketplace = payload, 
    
};

export default mutations